import gql from "graphql-tag";

export const UPDATE_ORGANIZATION_SETTINGS_FILTER = gql`
	mutation UpdateUserContextFiltersOrganizationSettings($req: String) {
		UpdateUserContextFiltersOrganizationSettings(req: $req)
	}
`;
export const GET_ORGANIZATION_SETTINGS_FILTERS = gql`
	query GetOrganizationSettingsFilters {
		filters: GetUserContextFiltersOrganizationSettings
	}
`;

export const GET_ALL_USERS_FROM_ORGANIZATION = gql`
	query GetAllUsersFromOrganization {
		GetAllUsersFromOrganization {
			id
			lastName
			firstName
		}
	}
`;
export const GET_ORGANIZATION_AGREEMENT_TAGS = gql`
	query GetOrganizationAgreementTags($id: String!) {
		GetOrganizationAgreementTags(id: $id)
	}
`;

export const GET_ORGANIZATION_DOMAINS = gql`
	query GetOrganizationDomains {
		domains {
			id
			name
			tenantId
			level
		}
	}
`;

export const GET_USER_DOMAINS_TREE = gql`
	query GetUserDomainsTree {
		GetUserDomainsTree {
			id
			name
			level
			children {
				id
				name
				level
				children {
					id
					name
					level
				}
			}
		}
	}
`;

export const GET_ORGANIZATION_DOMAINS_WITH_COUNTERS = gql`
	query GetOrganizationDomainsWithCounters {
		GetOrganizationDomainsWithCounters {
			names
			domains {
				id
				name
				tenantId
				level
				users {
					id
					firstName
					lastName
				}
				simulationCount
				parent {
					id
					name
				}
				children {
					id
					name
					level
					users {
						id
						firstName
						lastName
					}
					simulationCount
					children {
						id
						name
						level
						users {
							id
							firstName
							lastName
						}
						simulationCount
					}
				}
			}
		}
	}
`;

export const GET_DEFAULT_AGREEMENT_ROLES = gql`
	query GetDefaultAgreementRoles($input: OrgSettingsDataFilterInput!) {
		GetDefaultAgreementRoles(input: $input) {
			userId
			tagName
			tagType
			firstName
			lastName
			isAgreementAssignee
			caseAssignee
			documentAssignee
			role
		}
	}
`;

export const GET_GENERAL_CONFIGURATION = gql`
	query GetGeneralConfiguration($input: OrgSettingsDataFilterInput!) {
		GetGeneralConfiguration(input: $input) {
			firstName
			lastName
			email
			userId
			role
			hasOperativeDataAccess
		}
	}
`;

export const GET_GENERAL_CONFIGURATION_WITH_DOMAINS = gql`
	query GetGeneralConfigurationWithDomains($input: OrgSettingsDataFilterInput!) {
		GetGeneralConfigurationWithDomains(input: $input) {
			firstName
			lastName
			email
			userId
			role
			hasOperativeDataAccess
			domainIds
		}
	}
`;

export const GET_ALL_AGREEMENTS_SPECIFIC_ROLES_QUERY = gql`
	query GetAllAgreementsSpecificRoles($input: OrgSettingsDataFilterInput!) {
		GetAllAgreementsSpecificRoles(input: $input) {
			userId
			firstName
			lastName
			agreementName
			agreementId
			agreementUserRole
			agreementTags
		}
	}
`;

export const UPDATE_USER_ROLE = gql`
	mutation UpdateUserRole($id: String!, $isAdmin: Boolean) {
		UpdateUserRole(id: $id, isAdmin: $isAdmin)
	}
`;
export const REMOVE_MODULE = gql`
	mutation RemoveModule($id: String!, $moduleId: Int) {
		RemoveModule(id: $id, moduleId: $moduleId)
	}
`;
export const ADD_MODULE = gql`
	mutation AddModule($id: String!, $input: ModuleInput) {
		AddModule(id: $id, input: $input)
	}
`;
export const UPDATE_DEFAULT_USER_ROLE = gql`
	mutation UpdateDefaultUserRole($input: DefaultUserRoleUpdateInput!) {
		UpdateDefaultUserRole(input: $input)
	}
`;

export const ASSIGN_USER_TO_DOMAIN = gql`
	mutation AssignUserToDomain($input: AssignUserToDomainInput!) {
		AssignUserToDomain(input: $input)
	}
`;

export const APPLY_DEFAULT_USER_ROLES_TO_ALL = gql`
	mutation ApplyDefaultUserRolesToAll($input: ApplyUserRolesToAllInput!) {
		ApplyDefaultUserRolesToAll(input: $input)
	}
`;

export const CREATE_DOMAIN = gql`
	mutation CreateDomain($input: CreateDomainInput!) {
		CreateDomain(input: $input)
	}
`;

export const UPDATE_DOMAIN = gql`
	mutation UpdateDomain($input: UpdateDomainInput!) {
		UpdateDomain(input: $input)
	}
`;

export const DELETE_DOMAIN = gql`
	mutation DeleteDomain($id: ID!) {
		DeleteDomain(id: $id)
	}
`;

export const GET_USER_CREATED_SIMULATIONS_COUNT = gql`
	query GetUserCreatedSimulationsCount($getUserCreatedSimulationsCountArgsDto: GetUserCreatedSimulationsCountArgsDto!) {
		GetUserCreatedSimulationsCount(getUserCreatedSimulationsCountArgsDto: $getUserCreatedSimulationsCountArgsDto) {
			count
		}
	}
`;
